<template>
  <div class="page-view">
    <!-- 面包屑 -->
    <a-breadcrumb class="page-breadcrumb">
      <a-breadcrumb-item>系统设置</a-breadcrumb-item>
      <a-breadcrumb-item>成员管理</a-breadcrumb-item>
    </a-breadcrumb>
    <!-- 页面内容 -->
    <div class="page-content">
      <!-- 新增 -->
      <div class="tool-view">
        <a-button type="primary" @click="editMember()">新增成员</a-button>
      </div>
      <!-- 列表 -->
      <a-table
        :loading="loading"
        :columns="columns"
        :data-source="dataSource"
        :row-key="(record) => record.id"
        :pagination="pagination"
        @change="handleTableChange"
      >
        <!-- 操作 -->
        <template slot="operate" slot-scope="text, record">
          <!-- 编辑 -->
          <a class="operate-item" @click="editMember(record)" style="margin-right: 10px">编辑</a>
          <!-- 删除 -->
          <a-popconfirm
            :title="'您确定要将【' + record.username +'】从团队成员中删除吗？'"
            ok-text="确定"
            cancel-text="取消"
            @confirm="deleteMember(record)"
          >
            <!-- 管理后台绑定的合拍账号默认为管理员，不可删除 -->
            <a class="operate-item" :disabled="!!record.is_system">删除</a>
          </a-popconfirm>
        </template>
      </a-table>
    </div>
    <!-- 新增、编辑成员 -->
    <EditModal ref="EditModal" @success="getMemberList" />
  </div>
</template>

<script>
import { getMemberList, deleteMember } from '@/api/request'
import EditModal from './components-member/EditModal'
// 列字段
const columns = [
  {
    title: '合拍号',
    dataIndex: 'user_id',
    key: 'user_id'
  },
  {
    title: '姓名',
    dataIndex: 'username',
    key: 'username'
  },
  {
    title: '部门',
    dataIndex: 'dept_name',
    key: 'dept_name'
  },
  {
    title: '角色',
    dataIndex: 'role_name',
    key: 'role_name'
  },
  {
    title: '操作',
    dataIndex: 'operate',
    key: 'operate',
    scopedSlots: { customRender: 'operate' }
  }
]
export default {
  components: {
    EditModal
  },
  data () {
    return {
      // 列字段
      columns,
      // 数据源
      dataSource: [],
      // 加载
      loading: false,
      // 分页器
      pagination: {
        total: 0,
        current: 1,
        pageSize: 10,
        pageSizeOptions: ['10', '20', '30', '40', '50'],
        showSizeChanger: true
      },
    }
  },
  created () {
    this.getMemberList()
  },
  methods: {
    // 分页
    handleTableChange (pagination, filters, sorter) {
      this.pagination.current = pagination.current
      this.pagination.pageSize = pagination.pageSize
      this.getMemberList()
    },
    // 获取成员列表
    getMemberList () {
      this.loading = true
      const params = {
        page: this.pagination.current,
        page_size: this.pagination.pageSize
      }
      getMemberList(params).then(res => {
        const { code, data, msg } = res
        if (code === 0) {
          this.loading = false
          data.data.forEach(item => {
            // 将角色名称拼接在一起，以顿号隔开
            item.role.forEach((r, index) => {
              item.role_name = (item.role_name || '') + r.show_name + ((index + 1 >= item.role.length) ? '' : '、')
            })
            // 将部门名称拼接在一起，以顿号隔开
            item.dept.forEach((r, index) => {
              item.dept_name = (item.dept_name || '') + r.name + ((index + 1 >= item.dept.length) ? '' : '、')
            })
          })
          this.dataSource = data.data
          this.pagination.total = data.total
        } else {
          this.$message.error(msg)
        }
      })
    },
    // 新增、编辑成员
    editMember (record) {
      this.$refs['EditModal'].showModal(record)
    },
    // 删除成员
    deleteMember (record) {
      this.loading = true
      deleteMember({
        id: record.id
      }).then(res => {
        this.loading = false
        const { code, data, msg } = res
        if (code === 0) {
          this.getMemberList()
        } else {
          this.$message.error(msg)
        }
      })
    },
  }
}
</script>

<style lang="less" scoped>
.page-view {
  padding: 24px 32px;
}
.tool-view {
  margin: 0 0 24px;
  display: flex;
  justify-content: flex-end;
}
</style>